import React,{useEffect, useState } from "react";
import Content from "./Content";
import SideBar from "../sidebar/SideBar";
import { useSelector,useDispatch } from "react-redux";
import { logout } from "../../reducers/actions/auth";
import { Navigate } from "react-router-dom";
const HomePage = () => {

    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const dispatch = useDispatch();

    const [isOpen, setIsopen] = useState(true);
    const ToggleSidebar = () => {
        isOpen === true ? setIsopen(false) : setIsopen(true);
    }

    const props = {
        isOpen: isOpen,
        ToggleSidebar: ToggleSidebar,
        title: ""
    }

    if (!isLoggedIn) {
        dispatch(logout());
        sessionStorage.clear();
         localStorage.clear();
         return <Navigate to="/login" replace />;
     }

    
    return (
        <>
            <SideBar  {...props} />
            <Content {...props} />
        </>
    );
}

export default HomePage;
